import Helpers from '../helpers'

export default {
    mixins: [Helpers],

    methods: {
        trackViewItemPSF() {
            let price = _.get(apr, 'psf_search_results.best_rate') || _.get(this, 'hotel.overview.prices.avg');

            if (!this.viewItemRegistered && price > 0) {
                dataLayer.push({
                    'event': 'view_item',
                    'ecommerce': {
                        'currency': '',
                        'value':  price,
                        'items': [
                            {
                                'item_id': `PSF ${_.get(this.hotel, 'hotel_id')}`,
                                'item_name': `${_.get(this.hotel, 'airport.code')} ${_.get(this.hotel, 'name')}`,
                                'coupon': '',
                                'currency': '',
                                'discount': 0,
                                'item_list_position': 0,
                                'item_category': this.getLotCategory('PSF'),
                                'item_list_name': '',
                                'price': price,
                                'salesTaxIncluded': false,
                                'feesIncluded': false,
                                'fees': 0.00,
                                'tax' : 0.00,
                                'quantity': 1,
                            },
                        ],
                    }
                });

                this.viewItemRegistered = true;
            }
        },
    }
}